export default function mixin(target, source) {
  Object.getOwnPropertyNames(source).forEach(function(name) {
    if (name !== 'constructor') {
      Object.defineProperty(target, name, Object.getOwnPropertyDescriptor(source, name));
    }
  });
}
